<template>
  <div>
    <div style="display: flex">

      <div class="col-12 col-md-3" id="root_contact_container"
           style="min-width:350px !important;height: 97vh;overflow: hidden;">
        <div class="chats custom_scroll_bar ">
          <div class="search-bar"
               style="display: inline-flex;width: 100%; position: sticky;top: 0;background: white;z-index: 100;padding-left: 20px;padding-right: 20px;">
            <img class="circle-img " style="cursor: pointer" @click="$router.push({path:'/profile-tab'})"
                 :src="get_user_image()"/>

            <v-text-field
              placeholder="جستجوی گفتگو"
              v-model="searchQuery"
              dense
              outlined
              style="border-radius: 10px;padding-right: 10px "
              append-icon="mdi-magnify"
            ></v-text-field>
          </div>

          <hr>
          <!--          ********************************-->
          <div class="chat-list cl" v-if="tm_operation!=null" id="tm_list"
               style="padding-left: 15px;padding-right: 15px;padding-top: 5px;margin: 0">
            <div class="chat-prev" v-on:click="goToTm()">

              <div class="row " style="padding-bottom: 10px">
                <!--                <div class="col-2">-->
                <!--                  <img :src="get_user_image()" class="circle-img"/>-->
                <!--                </div>-->
                <div class="col-10">
            <span class="time">
              امروز
            </span>
                  <span class="count">
              {{ tm_operation.length }}
              </span>
                  <span class="name">
                  وظایف شما
            </span>
                  <span class="text">
              <span style="color:#3c3c3c;font-weight: 300;">
                  وظایف انجام نشده شما ({{ tm_operation.length }})
              </span>
              </span>
                </div>
              </div>

            </div>

          </div>

          <!--          ********************************-->
          <div class="chat-list" v-for="item in fConversations_sort" :key="item.GetReceiver"
               style="padding-left: 15px;padding-right: 15px;padding-top: 5px;margin: 0">
            <!--        <div class="chat-prev"  v-on:click="goToDetail(item)" @contextmenu="openMenu">-->
            <!--        <div class="chat-prev" @contextmenu="openMenu($event, item)" v-on:click="goToDetail(item)">-->
            <div class="chat-prev" v-on:click="goToDetail(item)">

              <div class="row">
                <div class="col-2">
                  <img style="width: 50px;height: 50px;object-fit: cover;border-radius: 50%;"
                       :src="item.ProcessThumb.replace('http://','https://')"/>
                </div>
                <div class="col-10">
            <span class="time">
              {{ get_conversation_date(item) }}
            </span>
                  <span class="count" v-if="item.UnReadCount != 0 && item.UnReadCount < 100">
              {{ item.UnReadCount }}
            </span>
                  <span class="count" v-if="item.UnReadCount != 0 && item.UnReadCount >= 100">
              +99
            </span>
                  <span class="name">
                  {{ item.ProcessName }}
            </span>
                  <span v-if="item.typing_text == null" class="text">
              <span v-if="item.MessageText!=''">
                    {{ item.MessageText }}
              </span>
                    <span v-else>
<v-icon style="transform: rotate(45deg);font-size: 21px;">mdi-paperclip</v-icon>
                    فایل پیوست
              </span>

                    <!--                {{ long }}-->
              </span>
                  <span v-else class="text">
              {{ item.typing_text }}
                    <!--                {{ long }}-->
              </span>
                  <v-menu
                    v-model="showMenu"
                    :position-x="x"
                    :position-y="y"
                    absolute
                    offset-y
                  >
                    <v-list>

                      <v-list-item>
                        <v-list-item-title>
                      <span v-on:click="goToDetail(show_detail)">
                        نمایش
                      </span>
                        </v-list-item-title>
                      </v-list-item>
                      <v-list-item>
                        <v-list-item-title>
                      <span v-on:click="removeMessage()">
                        حذف
                      </span>
                        </v-list-item-title>
                      </v-list-item>
                    </v-list>
                  </v-menu>

                </div>
              </div>

            </div>

          </div>
          <infinite-loading @infinite="get_all_conversations">
            <div slot="no-more"></div>
          </infinite-loading>
          <div class="start-conversation" v-on:click="goToContact()">
            <img src="/img/icons/chat.svg">

          </div>
        </div>

      </div>


      <!--      <div id="resize_drageable" style="width: 5px;height: 97vh;cursor: col-resize"></div>-->


      <div class="col-md-9" id="root_chat_container" style="padding: 0 !important;">
        <div v-if="!get_ismobile() && is_chat_selected && !is_contact_selected">
          <ChatDetail/>
        </div>
        <div v-if="!get_ismobile() && is_contact_selected">
          <ContactInfo/>
        </div>
        <div v-if="!get_ismobile() && is_tm_selected ">
          <TmLists/>
        </div>
      </div>

    </div>

    <v-dialog
      v-model="dialog"
      persistent
      max-width="290"
    >
      <v-card class="remove-card">

        <v-card-text>
          آیا از حذف این مکالمه اطمینان دارید؟
        </v-card-text>
        <v-card-actions>

          <v-btn
            class="accept-btn"
            text
            @click="dialog = false"
          >
            تایید
          </v-btn>
          <v-btn
            class="cancle-btn"
            text
            @click="dialog = false"
          >
            انصراف
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>
<script>
import Longpress from 'vue-longpress'
import {bus} from '../../main.js'
import Vue from 'vue'
import ChatDetail from './ChatDetail'
import ContactInfo from './ContactInfo'
import Badger from '../../badger'
import EmojiViewer from './chat_detail/EmojiViewer'
import InfiniteLoading from 'vue-infinite-loading'
import TmLists from '../TmOperation/TmLists'
import moment from 'moment-jalaali'

export default {
  data() {
    return {
      page: 1,
      conversations: [],
      fConversations: [],
      date_now: '',
      searchQuery: null,
      long: 0,
      startTime: 0,
      endTime: 0,
      showMenu: false,
      dialog: false,
      show_detail: '',
      cnt: 1,
      x: 0,
      y: 0,
      is_chat_selected: false,
      is_contact_selected: false,
      is_tm_selected: false,
      // myBadger: null,
      tm_operation: null,
    }
  },
  components: {
    Longpress,
    EmojiViewer,
    ChatDetail,
    InfiniteLoading,
    TmLists,
    ContactInfo
  },
  mounted() {
    let width = localStorage.getItem('root_chat_container_width');
    if (width != null) {
      document.getElementById("root_chat_container").style.width = width + '%'
      document.getElementById("root_contact_container").style.width = 100 - width + '%'

    }


    const conver = localStorage.getItem('messenger_conversations')
    console.log('lod conv')
    if (conver != null && conver != '') {
      console.log('lod conv2')

      if (localStorage.getItem('zoodpayam_phone') == localStorage.getItem('messenger_conversations_user')) {
        this.date_now = moment().format('DD/MM/YYYY HH:mm')
        console.log('date now is', this.date_now)
        this.conversations = JSON.parse(localStorage.getItem('messenger_conversations'))
        this.fConversations = JSON.parse(localStorage.getItem('messenger_conversations'))
        console.log('lod conv 3', this.conversations)
      }
      this.get_all_conversations()
    }
    var self = this
    // const myBadgerOptions = {} // See: constructor for customization options
    // this.myBadger = new Badger(myBadgerOptions)

// Live update value example:

    bus.$on('signalr_methods2', (data) => {
      // console.log(this.GetReceiver)
      // console.log(data[1].sender)
      console.log('chats signal r methods is called bus')
      if (data[0] == 'is_typing') {
        this.fConversations.forEach(function (val) {
          if (data[1].sender == val.GetReceiver) {
            if (data[1].isTyping == 1) {
              Vue.set(val, 'typing_text', 'در حال تایپ...')
            } else {
              Vue.set(val, 'typing_text', null)
            }
          }
        })
      }
      //* ***********************************
      if (data[0] == 'get_message') {
        var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
        var my_user_id = localStorage.getItem('userId2')
        this.fConversations.forEach(function (val) {
          if (data[1].RecType == 0) {
            if (data[1].ReceiverId == val.GetReceiver && data[1].CurrentUserId == my_user_id) { // my message
              Vue.set(val, 'SubmitDateTimeMiladi', data[1].SubmitDateTimeEn.replace('  ', ' '))
              Vue.set(val, 'SubmitDateTime', data[1].SubmitDateTime)
              Vue.set(val, 'MessageText', data[1].Message)
              // console.log('conv data receiver ', data[1].ReceiverId, " data currrent ", data[1].CurrentUserId, " conv receiver", val.GetReceiver)
            }

            if (data[1].CurrentUserId == val.GetReceiver && data[1].CurrentUserId != my_user_id) { // other message
              Vue.set(val, 'UnReadCount', val.UnReadCount + 1)
              Vue.set(val, 'SubmitDateTimeMiladi', data[1].SubmitDateTimeEn.replace('  ', ' '))
              Vue.set(val, 'SubmitDateTime', data[1].SubmitDateTime)
              Vue.set(val, 'MessageText', data[1].Message)
              // self.myBadger.value = self.myBadger.value + 1
            }
          } else {
            if ((data[1].ReceiverId == val.GetReceiver)) {
              Vue.set(val, 'SubmitDateTimeMiladi', data[1].SubmitDateTimeEn.replace('  ', ' '))
              Vue.set(val, 'SubmitDateTime', data[1].SubmitDateTime)
              Vue.set(val, 'MessageText', data[1].Message)
              // console.log('conv data receiver ', data[1].ReceiverId, " data currrent ", data[1].CurrentUserId, " conv receiver", val.GetReceiver)
            }
          }
        })
      }
      //* ***********************************
    })

    bus.$on('contact_chat_info_update', (data) => {
      this.is_chat_selected_fn()
      this.is_contact_selected_fn()
      //* ***********************************
    })
    // window.addEventListener('resize', this.resize_mobile, {passive: true})
    // this.resize_mobile()
    this.get_tm_op()
    this.is_chat_selected_fn()
    this.is_contact_selected_fn()
    this.dragable()
  },
  watch: {
    searchQuery: function (val) {
      this.resultQuery()
    },

  },
  computed: {
    fConversations_sort() {
      var self = this
      return this.fConversations.sort(function (a, b) {
        // Turn your strings into dates, and then subtract them
        // to get a value that is either negative, positive, or zero.
        return self.convert_string_to_date_obj(b.SubmitDateTimeMiladi, b) - self.convert_string_to_date_obj(a.SubmitDateTimeMiladi, a)
      })
    },
  },
  methods: {
    dragable() {
      var dragObj = null

      var obj = document.getElementById('resize_drageable')
      // obj.style.position = "absolute";
      obj.onmousedown = () => {
        dragObj = obj
        window.addEventListener('selectstart', function (e) {
          e.preventDefault();
        });

      }

      document.onmouseup = (e) => {
        dragObj = null
        window.removeEventListener('selectstart', function (e) {
          e.preventDefault();
        });

      }

      document.onmousemove = (e) => {
        var x = e.pageX

        if (dragObj == null) {
          return
        }
        console.log("left", e.pageX)

        // dragObj.style.left = x + 'px'
        let width = ((x * 100) / window.innerWidth)
        localStorage.setItem('root_chat_container_width', width)
        document.getElementById("root_chat_container").style.width = width + '%'
        document.getElementById("root_contact_container").style.width = 100 - width + '%'
      }
    },
    is_chat_selected_fn() {
      var chat = localStorage.getItem('lastChat')
      if (chat != 'null' && chat != null) {
        // console.log("is_chat_selected is true")

        this.is_chat_selected = true
        this.is_tm_selected = false
      } else {
        // console.log("is_chat_selected is false")

        this.is_chat_selected = false
      }
    },
    is_contact_selected_fn() {
      var chat = localStorage.getItem('LastUserInfo')
      if (chat != 'null' && chat != null) {
        console.log('is contact sleected is true', chat)
        this.is_contact_selected = true
      } else {
        console.log('is contact sleected is false')

        this.is_contact_selected = false
      }
    },
    removeMessage() {
      this.dialog = true
    },

    openMenu(e, item) {
      console.log('open', item)
      this.show_detail = item
      e.preventDefault()
      this.showMenu = false
      this.x = e.clientX
      this.y = e.clientY
      this.$nextTick(() => {
        this.showMenu = true
      })
    },

    resultQuery() {
      this.fConversations = this.conversations.filter(post => {
        return post.ProcessName.toLowerCase().includes(this.searchQuery)
      })
    },

    goToDetail(item) {
      // this.myBadger.value = this.myBadger.value - item.UnReadCount

      Vue.set(item, 'UnReadCount', 0)

      const last_chat_detail = {
        RecType: item.RecType,
        UserOrGroupId: item.UserOrGroupId,
        GetReceiver: item.GetReceiver
      }
      localStorage.setItem('LastUserInfo', null)
      // localStorage.setItem("lastChat", null)
      // this.is_chat_selected_fn()
      // this.is_contact_selected_fn()

      // setTimeout(() => {
      localStorage.setItem('lastChat', JSON.stringify(last_chat_detail))
      this.is_chat_selected_fn()
      this.is_contact_selected_fn()

      if (this.get_ismobile()) {
        console.log('this is info is true router changed')

        this.$router.push({name: 'مکالمه', params: {}})
      } else {
        console.log('this is info is false bus emited')

        bus.$emit('contact_chat_info_update', true)
        bus.$emit('chat_detail_update', true)
      }
      // }, 100);
    },
    goToTm() {
      if (this.get_ismobile()) {
        this.$router.push({path: '/tm_list'})
      } else {
        console.log('this is info is false bus emited')
        this.is_tm_selected = true
        this.is_chat_selected = false
        this.is_contact_selected = false
      }
    },
    get_tm_op() {
      var self = this
      var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
      var phone = localStorage.getItem('zoodpayam_phone')
      phone = phone.replace('+98', '')
      var password = localStorage.getItem('zoodpayam_password')
      const send_data = {
        UserId: user_id,
        CurrentDate: new Date().toJSON().slice(0, 10),
      }
      // X-Content-Type-Options: nosniff
      const headers = {
        'Content-Type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
      }

      this.axios.post('https://panel.zoodkomak.com/Maintenance/GetMaintenanceOperationsByDateUserId', send_data, {})
        .then(response => {
          if (response.data.Error == 0) {
            self.tm_operation = response.data.Data.Items
          } else {
            self.tm_operation = null
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        // this.errors.push(e);

      })
    },
    get_all_conversations($state) {
      // return false
      var self = this
      console.log('load chatas all ', self.page)
      var user_id = JSON.parse(localStorage.getItem('zoodpayam_profile')).UserId
      var phone = localStorage.getItem('zoodpayam_phone')
      phone = phone.replace('+98', '')
      var password = localStorage.getItem('zoodpayam_password')
      const send_data = {
        Phone: phone,
        Password: password,
        LastItemId: 0,
        Row: self.page,
      }
      // X-Content-Type-Options: nosniff
      const headers = {
        'Content-Type': 'application/json',
        'X-Content-Type-Options': 'nosniff',
      }
      // this.axios.defaults.headers.common['X-Content-Type-Options'] = 'nosniff' // for all requests

      // this.axios.post('/Register' , send_data,{
      this.axios.post('/GetConversation', send_data, {show_pros: false})
        .then(response => {
          if (response.data.error == 0) {
            self.date_now = response.data.dateNow
            if (self.page == 1) {
              self.conversations = []
              self.fConversations = []
            }
            self.conversations.push(...response.data.conversation)
            self.fConversations.push(...response.data.conversation)
            console.log('conversation loaded ', self.page, self.conversations[0])
            self.$forceUpdate()

            if (response.data.conversation.length == 10) {
              self.page = self.page + 1
              if (self.page == 2) {
                self.get_all_conversations()
              }
              $state.loaded()
              // this.get_all_conversations(page)
            } else {
              var unreads = 0
              self.fConversations.forEach(function (val) {
                unreads += val.UnReadCount
              })
              $state.complete()
            }

            localStorage.setItem('messenger_conversations_user', localStorage.getItem('zoodpayam_phone'))
            localStorage.setItem('messenger_conversations', JSON.stringify(self.fConversations))
          } else {
            self.not_register = true
          }
          // this.$router.push({ path: "/post-login", params: {} });
        }).catch(e => {
        // this.errors.push(e);

      })
    },
    convert_string_to_date(date) {
      var dateString = date

      var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
      var dateArray = reggie.exec(dateString)

      // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
      var dateObject = new Date(
        (+dateArray[3]),
        (+dateArray[2]), // Careful, month starts at 0!
        (+dateArray[1]),
        (+dateArray[4]),
        (+dateArray[5]),
        (+dateArray[5])
      )
      return dateObject.toDateString()
    },
    convert_string_to_date_obj(date, obj) {
      var dateString = date

      var reggie = /(\d{2})\/(\d{2})\/(\d{4}) (\d{2}):(\d{2})/
      var dateArray = reggie.exec(dateString)

      // var date = dateArray[3]+"-"+dateArray[2]+"-"+dateArray[1]+"T00:00:00.000+03:30"
      var dateObject = new Date(
        (dateArray[3]),
        (dateArray[2] - 1), // Careful, month starts at 0!
        (dateArray[1]),
        (dateArray[4]),
        (dateArray[5]),
        (dateArray[5])
      )
      // console.log("date time",dateObject,obj)
      return dateObject
    },
    get_conversation_date(item) {
      var date = item.SubmitDateTimeMiladi
      var days = 0
      var dateNow = new Date(this.convert_string_to_date(this.date_now))
      var conv_date = new Date(this.convert_string_to_date(date))
      // var conv_date_hour = new Date(date)
      var reportDate = date.substring(date.length - 5)

      days = dateNow - conv_date

      days = days / (1000 * 60 * 60 * 24)

      var ret
      if (days < 1) {
        ret = reportDate
      } else if (days >= 1 && days < 2) {
        ret = ' دیروز ' + reportDate
      } else if ((days < 8) && (days > 1)) {
        ret = parseInt(days) + ' روز قبل ' + (reportDate)
      } else {
        ret = item.SubmitDateTime.replace('-', ' ')
      }

      return ret
    },

    // get_conversation_date(date) {
    //   var days = 0;
    //   var dateNow = new Date(this.date_now)
    //   var conv_date = new Date(date)
    //
    //   var reportDate = conv_date.getHours() + ":" + conv_date.getMinutes()
    //   days = dateNow.getTime() - conv_date.getTime();
    //   days = days / (1000 * 60 * 60 * 24)
    //   var ret;
    //   if (days < 1) {
    //     ret = reportDate;
    //   } else if (days > 1 && days < 2) {
    //     ret = " دیروز " + reportDate;
    //   } else if ((days < 8) && (days > 1)) {
    //     ret = days + " روز قبل " + reportDate;
    //
    //   } else {
    //     ret = date;
    //   }
    //
    //   return ret;
    // },
    goToContact() {
      this.$router.push({path: '/contacts', params: {}})
    },
  }
}
</script>
